import { ObjectDb } from './object.db';
import { Injectable } from '@angular/core';
import {
    ServiceSpecialistRecordContactTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-contact-type.object';

@Injectable({ providedIn: 'root' })
export class ServiceSpecialistRecordContactTypeDb extends ObjectDb<ServiceSpecialistRecordContactTypeObject> {

    public tableName = 'serviceSpecialistRecordContactType';

    protected override columnMap = {
        serviceId: 'serviceId',
        name: 'name',
        active: 'active',
    };
    protected override indices = ['id'];
    protected override checkField = 'createdAt';

    protected gqlMethod = 'getServiceSpecialistRecordContactTypes';

    protected syncFragment = `
        id
        name
        description
        active
        serviceId
        createdAt
    `;

}
